define([
	"dojo/_base/declare",
	"csi/comm",
	"csi/def",
	"csi/table/Widget",
	"csi/xml"
], function(declare,comm,def,Table,xml) {

	var	_types = {
		StyleColor: "CollectionColor",
		StyleMaterial: "CollectionMaterial",
		StyleMainMaterial: "CollectionMaterial"
	};

	return declare(Table, {
		setViewNode: function(/*Node*/node, /*Boolean*/bSaveSelections) {
			// summary: prefNodeContext needs to vary based on product type
			var	type;

			if (node) {
				var request = comm.getNodeRequest(xml.getUrlPath(node.Master, "Child:Proto/Child:TrackingType"));
				if (request) {
					var	response = request.go({sync:true});
					var	tt = response ? response.getResultNode() : null;

					if (type = tt ? (_types[tt.$Name] || tt.$Name) : null) {
						this.prefKey = this.defView.getKey(type);
					}
				}
			} else if (this.customViewMigrationContainerKey) {
				// if node not given but key is, then extract type from key
				type = def.decomposeViewKey(this.customViewMigrationContainerKey).context;
			}

			if (type) {
				this.relRoot.m_target = type;
			}

			this.inherited(arguments);
		}
	});
});